import { FC, ComponentProps } from 'react';
import { Locale } from 'dibs-intl/exports/constants';
import { useIntl } from 'dibs-react-intl';
import {
    LOCALE_US,
    LOCALE_GB,
    LOCALE_DE,
    LOCALE_FR,
    LOCALE_PSEUDO,
} from 'dibs-intl/exports/constants';
import LogoVip from 'dibs-icons/exports/LogoVip';
import LogoVipDe from 'dibs-icons/exports/LogoVipDe';
import LogoVipFr from 'dibs-icons/exports/LogoVipFr';

type Props = ComponentProps<typeof LogoVip | typeof LogoVipDe | typeof LogoVipFr>;

export const LocalizedLogoVipIcon: FC<Props> = props => {
    const { locale } = useIntl();

    const logoLookup: Record<Locale, FC<Props>> = {
        [LOCALE_PSEUDO]: LogoVip,
        [LOCALE_US]: LogoVip,
        [LOCALE_GB]: LogoVip,
        [LOCALE_DE]: LogoVipDe,
        [LOCALE_FR]: LogoVipFr,
    };

    const Component = logoLookup[locale] || LogoVip;

    return <Component {...props} />;
};
